import { render, staticRenderFns } from "./CaseUploads.vue?vue&type=template&id=34b96950"
import script from "./CaseUploads.vue?vue&type=script&lang=js"
export * from "./CaseUploads.vue?vue&type=script&lang=js"
import style0 from "./CaseUploads.vue?vue&type=style&index=0&id=34b96950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports